import React,{Component} from "react";
import { Row, Col, Card, CardHeader, CardBody, Button,
  FormSelect,
 } from "shards-react";


import { AtomSpinner } from 'react-epic-spinners';

export default class ViewTimeTable extends Component{


  constructor(props) {
    super(props);

    this.state = {
        class_selected:"Select Class",
    };

    this.onClassChange  = this.onClassChange.bind(this);
    this.add_button_descision_maker = this.add_button_descision_maker.bind(this);
  
  }

  onClassChange=(evt)=>{
      this.setState({class_selected:evt.target.value});
      this.props.set_class(evt.target.value);
  }

  add_button_descision_maker=()=>{
    return !(this.state.class_selected==="Select Class" || this.state.class_selected==="No Class Available")
  }

  render(){
    return(
  
    
<Col>
    <Card small className="mb-4"  >
        <CardHeader className="border-bottom">
          <h6 className="m-0">TimeTable</h6>
        </CardHeader>
        
    <CardBody className="pt-0 scroll_list-group">
          <Row className="border-bottom py-2 bg-light">
            <Col sm="12" className="d-flex mb-2 mb-sm-0">
                
                <ClassList class_list={this.props.class_list} 
                            loading={this.props.loading}
                            onChange={this.onClassChange}
                
                  />

            {
              this.add_button_descision_maker() && 
                  
              <Col md="12" className="form-group">
                  <Button theme="danger" onClick={this.props.add_timetable}>Add</Button>
              </Col>
            }           
            </Col>
            
          </Row>
        { (!this.props.loading && this.props.table_data.length>0) && 
          <table className="table mb-0 ">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Subject
                  </th>
                  <th scope="col" className="border-0">
                      Start Time
                  </th>
                  <th scope="col" className="border-0">
                      End Time
                  </th>
                  <th scope="col" className="border-0">
                      Faculty/Teacher
                  </th>
                 
                  <th scope="col" className="border-0">
                      Delete
                  </th>
                  
                </tr>
              </thead>
             <tbody>
                {
                    this.props.table_data.map((item,i)=>{
                      return <TRow  data={item} 
                                    key={i} 
                                    index={i+1} 
                                    askdelete={this.props.askdelete}
                                    get_selected_class={()=>{return this.state.class_selected}}            
                                    />
                    })  
              }
                
              </tbody>
            </table>
            }

             {
                ( !this.props.loading && this.props.table_data.length===0 && (this.state.class_selected===undefined || this.state.class_selected==="Select Class" || this.state.class_selected==="No Class Available") ) &&
                
                <div style={{marginTop: '8%'}} className="text-muted">
                            <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                                  {"Please Select Class"}
                            </div>
                            <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                                 <i class="material-icons">call_missed</i>  
                            </div>                  
                  </div>

              }
              { 
              
                  (this.props.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
          

                  }


              {
                ( !this.props.loading && this.props.table_data.length===0 && !(this.state.class_selected===undefined || this.state.class_selected==="Select Class" || this.state.class_selected==="No Class Available") ) &&
                
                <div style={{marginTop: '8%'}} className="text-muted">
                            <div  style={{fontSize:40,textAlign: 'center',color:'blue' }}>
                                  {"Add Time Table"}
                            </div>
                            <div style={{margin: '2%',marginLeft: "0%",fontSize: 60,textAlign: 'center',color:'blue'}}>
                                 <i class="material-icons">arrow_upward</i>  
                            </div>                  
                  </div>

              }

          
        </CardBody>
      </Card>
</Col>

    )
  }
}

class TRow extends Component{

  constructor(props) {
    super(props);
  
    this.prepare_delete = this.prepare_delete.bind(this);
  }

  prepare_delete = ()=>{
       var data = {
                    id:this.props.data.id,
                    class:this.props.get_selected_class(),
                    day:undefined,
                  }
      this.props.askdelete(data);
  }

  render(){
    return(
          <tr>
                  <td>{this.props.index}</td>
                  <td>{this.props.data.subject}</td>
                  <td>{this.props.data.start_time}</td>
                  <td>{this.props.data.end_time}</td>  
                  <td>{this.props.data.faculty}</td>
                  <td style={{fontSize:30,color:'red'}} onClick={this.prepare_delete}>
                        <i class="material-icons">delete</i>
                  </td>
          </tr>
      )
  }
}



class ClassList extends Component{
  render(){
    return(
    <Col md="4" className="form-group">

          <FormSelect onChange={this.props.onChange}>
                  <option>{this.props.loading?"Loading...":(this.props.class_list.length>0?"Select Class":"No Class Available")}</option>
                                          {

                                              this.props.class_list.map((item,i)=>{
                                                             return (<option key={i}>{item}</option>)
                                               })
                                           }
        </FormSelect>

    </Col>
    )
  }
}